import { render, staticRenderFns } from "./UserStaffUpdate.vue?vue&type=template&id=08afca1e&"
import script from "./UserStaffUpdate.vue?vue&type=script&lang=js&"
export * from "./UserStaffUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports